import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { paymentsApi } from '../api/paymentsApi';
import type { ListPaymentsParams } from '../types';

export const usePayments = (params?: ListPaymentsParams) =>
  useQuery({
    queryKey: ['payments', params],
    queryFn: () => paymentsApi.list(params),
    staleTime: 30 * 1000,
    placeholderData: keepPreviousData,
  });
